"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectRange = void 0;
var selectRange = function selectRange(rangeType) {
  return {
    type: 'RECEIVE_SELECTED_RANGE',
    rangeType: rangeType
  };
};
exports.selectRange = selectRange;